import { render, staticRenderFns } from "./ItemCard.vue?vue&type=template&id=e615471e&scoped=true&"
import script from "./ItemCard.vue?vue&type=script&lang=js&"
export * from "./ItemCard.vue?vue&type=script&lang=js&"
import style0 from "./ItemCard.vue?vue&type=style&index=0&id=e615471e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e615471e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e615471e')) {
      api.createRecord('e615471e', component.options)
    } else {
      api.reload('e615471e', component.options)
    }
    module.hot.accept("./ItemCard.vue?vue&type=template&id=e615471e&scoped=true&", function () {
      api.rerender('e615471e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/atm/components/cards/ItemCard.vue"
export default component.exports